import { FaArrowAltCircleUp } from "react-icons/fa";

const MoveUp = () => {
  const handleMoveUp = (e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="move-up">
      <span className="icon" onClick={handleMoveUp}>
        <FaArrowAltCircleUp size={"40px"} color="#ff9f31" />
      </span>
    </div>
  );
};
export default MoveUp;
